import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Industries from "../components/Industries";
import Process from "../components/Process";
import Portfolio from "../components/Portfolio";
import FinalCTA from "../components/FinalCTA";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import { contactInfo } from "../data/mock";
import { Helmet } from "react-helmet";



const HomePage = ({ scrollToContact, handleWhatsApp }) => {
  return (
    <>
      <Hero onGetQuote={scrollToContact} onWhatsApp={handleWhatsApp} />
      <Services />
      <Industries />
      <Process />
      <Portfolio />
      <FinalCTA onGetQuote={scrollToContact} />
      <ContactForm />
      <Footer />
    </>
  );
};

export default HomePage;
